<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-4 pb-0">
                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                LC Shipment Records
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="4" cols="12">
                    <div class="text-right">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/lc/import-lc-shipment-create')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Create Shipment
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="getLcImportLcShipmentList"
                  :search="search"
                  :loading="loading"
                  item-value="id"
                  class="elevation-1"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:item.shipment_no="{ item }">
                    {{ item.shipment_no }}
                  </template>

                  <template v-slot:item.code="{ item }">
                    {{ item.code }}
                  </template>

                  <template v-slot:item.shipment_date="{ item }">
                    {{ formatDateView(item.shipment_date) }}
                  </template>

                  <template v-slot:item.lc_master="{ item }">
                    {{ item.lc_master?.lc_no || item.lcMaster?.lc_no || item.lc_master?.code || item.lcMaster?.code || "N/A" }}
                  </template>

                  <template v-slot:item.etd="{ item }">
                    {{ item.etd ? formatDateView(item.etd) : "-" }}
                  </template>

                  <template v-slot:item.eta="{ item }">
                    {{ item.eta ? formatDateView(item.eta) : "-" }}
                  </template>

                  <template v-slot:item.shipment_value="{ item }">
                    {{ $numberFormat(item.shipment_value) }}
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :color="getStatusColor(item.status)"
                      size="small"
                      variant="tonal"
                    >
                      {{ item.status == '1' ? "Posted" : 'Draft' }}
                    </v-chip>
                  </template>

                  <template v-slot:item.shipment_status="{ item }">
                    <v-chip
                      :color="getShipmentStatusColor(item.shipment_status)"
                      size="small"
                      variant="tonal"
                    >
                      {{ item.shipment_status || "Draft" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.document_status="{ item }">
                    <v-chip
                      :color="getDocumentStatusColor(item.document_status)"
                      size="small"
                      variant="tonal"
                    >
                      {{ item.document_status || "PENDING" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.approval_status="{ item }">
                    <v-chip
                      :color="getApprovalStatusColor(item.approval_status)"
                      size="small"
                      variant="tonal"
                    >
                      {{ item.approval_status || "Pending" }}
                    </v-chip>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon="mdi-eye"
                      size="small"
                      variant="text"
                      color="info"
                      @click="viewItem(item.id)"
                    ></v-btn>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import { useField, useForm } from "vee-validate";
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";

export default {
  data: () => ({
    panel: [0],
    panel1: [0],
    loading: false,
    search: "",
    headers: [
      { title: "#SL", align: "center", key: "index", width: "5%", sortable: false },
      { title: "Shipment No", key: "shipment_no", align: "left", sortable: true },
      { title: "Shipment Code", key: "code", align: "left", sortable: true },
      { title: "Shipment Date", key: "shipment_date", align: "left", sortable: true },
      { title: "LC No", key: "lc_master", align: "left", sortable: false },
      { title: "ETD", key: "etd", align: "left", sortable: true },
      { title: "ETA", key: "eta", align: "left", sortable: true },
      { title: "Shipment Value", key: "shipment_value", align: "right", sortable: true },
      { title: "Status", align: "center", key: "status", sortable: true },
      { title: "Shipment Status", align: "center", key: "shipment_status", sortable: true },
      { title: "Document Status", align: "center", key: "document_status", sortable: true },
      { title: "Approval Status", align: "center", key: "approval_status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false, width: "10%" },
    ],
  }),
  setup() {
    const { handleSubmit } = useForm();
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const store = useStore();
    const router = useRouter();

    const getLcImportLcShipmentList = computed(() => {
      return store.getters.getLcImportLcShipmentList || [];
    });

    onMounted(() => {
      loadData();
    });

    const loading = ref(false);

    const loadData = async () => {
      try {
        loading.value = true;
        await store.dispatch("getLcImportLcShipmentList");
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to load Shipment records");
      } finally {
        loading.value = false;
      }
    };

    const submit = handleSubmit(async (values) => {
      // Filter/search logic can be added here if needed
      await loadData();
    });

    const getStatusColor = (status) => {
      var statusColor = (status == '1' ? "success" : "grey");
      return statusColor;
    };

    const getShipmentStatusColor = (status) => {
      const colors = {
        Draft: "grey",
        Shipped: "info",
        Arrived: "primary",
        Cleared: "success",
        Closed: "default",
      };
      return colors[status] || "grey";
    };

    const getDocumentStatusColor = (status) => {
      const colors = {
        PENDING: "warning",
        RECEIVED: "info",
        MISMATCH: "error",
        REJECTED: "error",
      };
      return colors[status] || "warning";
    };

    const getApprovalStatusColor = (status) => {
      const colors = {
        Pending: "warning",
        Approved: "success",
        Cancelled: "error",
      };
      return colors[status] || "warning";
    };

    const viewItem = (id) => {
      router.push({ path: `/lc/import-lc-shipment-view/${id}` });
    };

    const goTo = (val) => {
      router.push({ path: val }).catch((err) => {});
    };

    const exportToCSV = () => {
      toast.info("CSV export feature coming soon");
    };

    const exportToExcel = () => {
      toast.info("Excel export feature coming soon");
    };

    const exportToPDF = () => {
      toast.info("PDF export feature coming soon");
    };

    return {
      loading,
      from_date,
      to_date,
      getLcImportLcShipmentList,
      submit,
      viewItem,
      exportToCSV,
      exportToExcel,
      exportToPDF,
      loadData,
      getShipmentStatusColor,
      getStatusColor,
      getDocumentStatusColor,
      getApprovalStatusColor,
      goTo,
      formatDateView,
    };
  },
  methods: {},
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>

